import { onesignal_app_id } from 'config/Config';
import OneSignal from 'react-onesignal';

type PermissionChangeListener = (permission: boolean) => void;

/* This variable was added because this method is called multiple times within the initial-login flow, 
and the OneSignal SDK should be initialized just once. */
let oneSignalInitialized = false;

export async function initPushNotification(userId: number) {
  if (!onesignal_app_id) {
    return;
  }

  if (!oneSignalInitialized) {
    oneSignalInitialized = true;
    await OneSignal.init({
      appId: onesignal_app_id,
    });
    await OneSignal.login(String(userId));
    await OneSignal.Slidedown.promptPush();
  }
}

export async function unsubscribePushNotification() {
  await OneSignal.logout();
}

export async function getSubscriptionStatus() {
  return await OneSignal.User.PushSubscription.optedIn;
}

export async function showPromptPush() {
  await OneSignal.Slidedown.promptPush({ force: true });
}

export function addPermissionListener(
  permissionChangeListener: PermissionChangeListener
) {
  OneSignal.Notifications.addEventListener(
    'permissionChange',
    permissionChangeListener
  );
}

export function removePermissionListener(
  permissionChangeListener: PermissionChangeListener
) {
  OneSignal.Notifications.removeEventListener(
    'permissionChange',
    permissionChangeListener
  );
}
